
import { computed, reactive, ref } from "vue";
import SponsorPlatinum from "./SponsorsPlatinum.vue";
import SponsorGold from "./SponsorsGold.vue";
import SponsorSilver from "./SponsorsSilver.vue";
import { useStore } from "vuex";
import { SponsorData } from "@/models/events/sponsors/sponsorData";
export default {
  components: {
    SponsorPlatinum,
    SponsorGold,
    SponsorSilver,
  },
  async setup() {
    const store = useStore();
    const sponsorsPremium: Array<SponsorData> = reactive([]);
    const sponsorsGold: Array<SponsorData> = reactive([]);
    const sponsorsSilver: Array<SponsorData> = reactive([]);
    const validateExistDatas = ref(false);
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const sponsorFeatureValid = () => {
      if (eventData.value) {
        if (eventData.value.eventFeatures) {
          const featuresObject = eventData.value.eventFeatures;
          if (typeof featuresObject === "object") {
            const feature = featuresObject.find((el) => el.id === "sponsors");
            if (feature)
              if (!feature.isSelected) validateExistDatas.value = false;
          }
        }
      }
    };
    const getSponsors = async () => {
      const datas = await store.dispatch(
        "sponsors/getSponsors",
        eventData.value.id
      );
      if (datas.length != 0) {
        validateExistDatas.value = true;
        sponsorFeatureValid();
        sponsorsPremium.splice(0, sponsorsPremium.length);
        sponsorsGold.splice(0, sponsorsGold.length);
        sponsorsSilver.splice(0, sponsorsSilver.length);
        for (const sponsor of datas) {
          switch (sponsor.sponsorship) {
            case "Platinum":
              sponsorsPremium.push(sponsor);
              break;
            case "Gold":
              sponsorsGold.push(sponsor);
              break;
            case "Silver":
              sponsorsSilver.push(sponsor);
              break;
          }
        }
      } else {
        validateExistDatas.value = false;
      }
    };
    await getSponsors();
    return {
      sponsorsPremium,
      sponsorsGold,
      sponsorsSilver,
      validateExistDatas,
    };
  },
};
